import { render, staticRenderFns } from "./BackgroundSection.vue?vue&type=template&id=325307e0"
import script from "./BackgroundSection.vue?vue&type=script&lang=js"
export * from "./BackgroundSection.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSection.vue?vue&type=style&index=0&id=325307e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports